// extracted by mini-css-extract-plugin
export var deleteModal = "_fw-0";